<template>
  <div id="insertInformation" class="flex-column-success">
    <div class="mobile-head">
      <i class="back iconfont icon-arrow-left"></i>
      <h1>核酸检测点忙闲数据上报</h1>
    </div>
    <div id="successful">
      <div class="main">
        <div class="information">
          <p style="text-indent:2em">您已于<span class="datestyle">{{ this.postDate }}</span>提交<span
            class="matter"> {{this.stArea}} {{ this.bankName }} </span>核酸监测点的忙闲数据。</p>
          <p style="text-indent:2em">依据您提交的忙闲数据，目前该核酸检测点的忙闲状态是
            <span v-show="this.status==='非常空'||this.status==='较空闲'" style="color:  #00B050;font-weight: 700"> {{ this.status }}</span>
            <span v-show="this.status==='较繁忙'||this.status==='非常繁忙'" style="color: #FF0000;font-weight: 700"> {{ this.status }}</span>
            。</p>
        </div>
      </div>
    </div>

    <button @click="comeBack" class="confirm-btn">继续填写</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stArea:'',
      postDate: '',
      bankName: '',
      total: '',
      status: ''
    }
  },
  methods: {
    setStatus() {
      return this.total <= 30 ? this.status = '非常空' :
             this.total > 30 && this.total <= 60 ? this.status = '较空闲' :
             this.total > 60 && this.total <= 90 ? this.status = '较繁忙' :
             this.status = '非常繁忙'
    },
    comeBack() {
      this.$router.push({path: 'nucleic-acid-report'})
    },
    async getReportInfo() {
      this.overlayShow = true;
      try {
        const res = await this.$axios.post('/dev/convidDetec/getReportInfo', {
          stPlaceId: this.$route.query.stPlaceId, // 办理点id
        })
        if (res.status === 200) {
          this.bankName = res.data.stPlaceName
          this.postDate = res.data.dtUpdateTime
          this.total = res.data.nmQueueNum
          this.stArea = res.data.stArea
        }
        this.setStatus()
      } catch (e) {
        console.log(e)
      }
    },
  },
  created() {
    document.title=''
    this.getReportInfo()
  }
}
</script>

<style lang="less">
#successful {
  .main {
    padding-top: 0rem;
  }

  .information {
    font-size: .70rem /* 34/50 */;
    background-color: #fff;
    padding-top: 1rem /* 20/50 */;
    padding-right: 1rem;
    padding-left: 1rem;

    p {
      line-height: 1.36rem /* 68/50 */;

      .matter {
        font-weight: 700;
        color: rgba(0, 0, 0, 1);
        padding-left: 0.1rem;
        padding-right: 0.1rem;
      }

      .number, .time {
        color: @theme-color;
      }
    }

    a {
      color: @theme-color;
    }
  }

  .tips {
    padding: .4rem /* 20/50 */;
    font-size: .56rem /* 28/50 */;
    color: rgba(0, 0, 0, .5);
    line-height: 1.12rem /* 56/50 */;

    .tip-tit {
      color: rgba(0, 0, 0, 1);
    }
  }
}

.flex-column-success {
  display: flex;
  align-items: center;
  height: 100%;
  flex-direction: column;
}

.mobile-head {
  display: flex;
  align-items: center;
  width: 100%;
  height: 2.133rem /* 100/46.875 */;
  text-align: center;
  z-index: 9999;
  background-color: #eee6d1;
}

.mobile-head .back {
  width: 1.707rem /* 80/46.875 */;
  height: 100%;
  font-size: .768rem /* 36/46.875 */;
  line-height: 2.133rem /* 100/46.875 */;
}

.mobile-head h1 {
  margin: 0;
  flex: 1;
  height: 100%;
  font-size: .64rem /* 30/46.875 */;
  line-height: 2.133rem /* 100/46.875 */;
  padding-right: 1.707rem /* 80/46.875 */;
}

.confirm-btn {
  width: 80%;
  height: 2.048rem /* 96/46.875 */;
  font-size: .683rem /* 32/46.875 */;
  line-height: 2.048rem /* 96/46.875 */;
  padding: 0;
  margin: .683rem /* 32/46.875 */ 0;
  outline: none;
  border: none;
  color: rgba(255, 255, 255, 1);
  border-radius: .171rem /* 8/46.875 */;
  background: linear-gradient(to right, #e4c995, #b9916a);
}

.datestyle {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-weight: 400;
  color: #cbb486;
}

</style>
